export default function readAsArrayBuffer(
    file: File,
): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
        try {
            const reader = new FileReader();
            reader.onloadend = () => {
                const res = reader.result;
                if (res) resolve(res);
                else reject();
            };
            reader.readAsArrayBuffer(file);
        } catch (e) {
            reject(e);
        }
    });
}
